/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/26/22
 */

import React from "react";
import {FormControl, FormHelperText, InputLabel, ListSubheader, MenuItem, Select} from "@mui/material";
import {useSelector} from "react-redux";
import {State} from "../state/store";
import {useQuery} from "urql";
import {SavedCalendarsQuery, SavedCalendarsQueryVars, SavedCalendarsResponse} from "../graphql/queries/calendars";

export interface LinkedCalendarSelectorProps {
	calendarId: number | undefined
	setCalendarId: (id: number | undefined) => void
	hint?: string
}

export default function LinkedCalendarSelector(props: LinkedCalendarSelectorProps) {

	const user = useSelector((s:State) => s.user);
	const favorites = useSelector((s:State) => s.favorites);

	const [ myCalendarsResult ] = useQuery<SavedCalendarsResponse, SavedCalendarsQueryVars>({
		query: SavedCalendarsQuery,
		variables: {
			createdBy: user?.id,
			orderBy: "-id"
		}
	});

	const [ favoriteCalendarsResult ] = useQuery<SavedCalendarsResponse, SavedCalendarsQueryVars>({
		query: SavedCalendarsQuery,
		variables: {
			idIn: favorites
		},
		pause: favorites.length === 0
	});

	const favoriteCalendars = (favorites.length > 0 && favoriteCalendarsResult.data?.savedCalendars.items) || [];
	const myCalendars = myCalendarsResult.data?.savedCalendars.items || [];

	return (
		<FormControl variant={"standard"}>
			<InputLabel>Linked Calendar</InputLabel>
			<Select
				value={props.calendarId || "no"}
				onChange={(event) => {
					const value = event.target.value;
					props.setCalendarId(value === "no" ? undefined : Number(value));
				}}
			>
				<MenuItem value={"no"}>No Linked Calendar</MenuItem>
				<ListSubheader>My Calendars</ListSubheader>
				{myCalendars.length === 0 && <MenuItem disabled>No saved calendars</MenuItem>}
				{myCalendars.map(c => <MenuItem key={c.id} value={c.id}>[{c.id}] {c.title}</MenuItem>)}
				<ListSubheader>Favorite Calendars</ListSubheader>
				{favoriteCalendars.length === 0 && <MenuItem disabled>No favorite calendars</MenuItem>}
				{favoriteCalendars.map(c => <MenuItem key={c.id} value={c.id}>[{c.id}] {c.title}</MenuItem>)}
			</Select>
			{ props.hint && <FormHelperText>{props.hint}</FormHelperText>}
		</FormControl>
	);

}